// AI Generated Service
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * @description Control Label Context
 */
@Injectable({
    providedIn: 'root',
})
export class LabelTableService {
    public labelTxtVisibility = new BehaviorSubject<boolean>(false);
    public editable = false;
    public canAssignLabels = false;
    public canManageLabels = false;

    /**
     * @desc Hides the Label text in the Label Table Container
     * @return {void}
     */
    public hideLabelTxt (): void {
        this.labelTxtVisibility.next(false);
    }

    /**
     * @desc Shows the Label text in the Label Table Container
     * @return {void}
     */
    public showLabelTxt (): void {
        this.labelTxtVisibility.next(true);
    }

    /**
     * @desc Set editable variable
     * @param {boolean} bool - The boolean value to set
     * @return {void}
     */
    public setEditable (bool: boolean): void {
        this.editable = Boolean(bool);
    }

}
